import { render, staticRenderFns, recyclableRender, components } from "./startWatchVideo.vue?vue&type=template&id=24813816&"
var renderjs
import script from "./startWatchVideo.vue?vue&type=script&lang=js&"
export * from "./startWatchVideo.vue?vue&type=script&lang=js&"
import style0 from "./startWatchVideo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "uni_modules/uce-course/pages/video/startWatchVideo.vue"
export default component.exports